import axios from 'axios';
import config from '@wearetla/tla-essentials-tools/config';

const localeCache = {};

/**
 * Lazily loads and caches a date-fns locale for the given language code.
 * Falls back to the axios request header language, then config default.
 *
 * @param {string} [language]
 * @returns {Promise<import('date-fns').Locale>}
 */
const getDateLocale = async (language) => {
	const resolved = language || axios.defaults.headers.common?.language || config.i18n?.defaultLanguage;
	const normalized = (resolved || 'tr').split('-')[0].toLowerCase();

	if (localeCache[normalized]) {
		return localeCache[normalized];
	}

	let locale;
	switch (normalized) {
		case 'en':
			locale = (await import('date-fns/locale/en-US')).default;
			break;
		default:
			locale = (await import('date-fns/locale/tr')).default;
	}

	localeCache[normalized] = locale;
	return locale;
};

export default getDateLocale;
